// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/search_query_language.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/search_query_language.proto.
 */
export const file_general_search_query_language: GenFile = /*@__PURE__*/
  fileDesc("CiNnZW5lcmFsL3NlYXJjaF9xdWVyeV9sYW5ndWFnZS5wcm90bxIOcHJvdG9zLmdlbmVyYWwqfQoTU2VhcmNoUXVlcnlMYW5ndWFnZRIhCh1TRUFSQ0hfUVVFUllfTEFOR1VBR0VfVU5LTk9XThAAEiEKHVNFQVJDSF9RVUVSWV9MQU5HVUFHRV9FTkdMSVNIEAESIAocU0VBUkNIX1FVRVJZX0xBTkdVQUdFX0ZSRU5DSBACYgZwcm90bzM");

/**
 * @generated from enum protos.general.SearchQueryLanguage
 */
export enum SearchQueryLanguage {
  /**
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_ENGLISH = 1;
   */
  ENGLISH = 1,

  /**
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_FRENCH = 2;
   */
  FRENCH = 2,
}

/**
 * Describes the enum protos.general.SearchQueryLanguage.
 */
export const SearchQueryLanguageSchema: GenEnum<SearchQueryLanguage> = /*@__PURE__*/
  enumDesc(file_general_search_query_language, 0);

